import styled from 'styled-components';
import { getColor, Fonts, StyleVars, spacingUnits } from 'core/utils';

export const svgPositionThreshold = 1150;
export const hideAdspaceThreshold = 815;

export const StyledSvgBlock = styled.a`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding: ${spacingUnits(1.75)} ${spacingUnits(1.75)} ${spacingUnits(1.75)} ${spacingUnits(0.75)};
	border-right: 2px solid ${getColor("alto")};
	margin-right: 20px;

	@media (max-width: ${svgPositionThreshold}px) {
		display: none;
	}
`;

export const StyledSvgHeader = styled.a`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 10px;
	padding: 0 8px;
	transition: all 0.2s linear;

	&:hover {
		border-left: 4px solid ${({ accentColor }) => accentColor || getColor("darkTeal")};
		background-color: rgba(200, 200, 200, 0.1);
	}

	@media (min-width: ${svgPositionThreshold}px) {
		display: none;
	}
`;

export const StyledDescriptionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const StyledDescription = styled.div`
	font-family: ${Fonts.serif};
	font-size: ${props => props.fontSize}px;
	font-weight: 600;
	line-height: 22px;
	letter-spacing: 0.2px;
	margin-top: ${({ marginTop }) => marginTop ? `${marginTop}px` : null};
	margin-left: ${({ marginLeft }) => marginLeft ? `${marginLeft}px` : null};
	color: ${getColor("gray")};
	text-decoration: none;

	&:hover, &:active {
		color: ${getColor("gray")};
	}
`;

export const ViewAllLink = styled.span`
	font-size: ${props => props.fontSize}px;
	font-weight: 600;
	line-height: 22px;
	letter-spacing: 0.2px;
	color: ${getColor("darkTeal")};
	text-align: right;
`;

export const SvgContainer = styled.div`
	margin-left: 50px;
	margin-right: 50px;
`;

export const StyledSubNavListItem = styled.a`
	color: ${getColor("gray")};
	font-family: ${Fonts.serif};
	font-size: 16px;
	white-space: nowrap;
	text-decoration: none;
	padding: 8px 12px 8px 0;

	&:hover, &:active {
		color: ${getColor("darkTeal")};
	}
`;

export const StyledSubNavListColumn = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 42px 0 20px;

	@media (max-width: ${svgPositionThreshold}px) {
		padding-left: 0;
	}

	&:last-of-type {
		${StyledSubNavListItem} {
			/* See issue #6357 SubNav could overflow without this */
			white-space: normal;
		}
	}
`;

export const ColumnTitle = styled.div`
	font-weight: 600;
	padding: 8px 0;
`;

export const AdContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	justify-content: flex-end;

	@media (max-width: ${hideAdspaceThreshold}px) {
		display: none;
	}
`;

export const SubNavContentContainer = styled.div`
	display: flex;
	flex-direction: row;
`;

export const SubNavContainer = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	z-index: 1000;
	top: 0;
	left: 0;
	right: 0;
	margin: auto;
	width: 100%;
	max-width: ${StyleVars.fixedwidthMax};
	border: 1px solid ${getColor("alto")};
	border-bottom: none;
	border-top: none;
	background: #fff;
	box-shadow: inset 0 2px 2px 0 rgba(190, 190, 190, 0.5);
	padding: 25px 24px 17px 24px;

	@media (max-width: ${svgPositionThreshold}px) {
		padding-top: 16px;
	}

	/* thick colored border under the subnav */
	&:after {
		position: absolute;
		width: calc(100% + 2px);
		max-width: ${StyleVars.fixedwidthMax};
		left: 0;
		height: 8px;
		bottom: -8px;
		background: ${props => props.accentColor};
		content: '';
		border-radius: 0 0 4px 4px;

		/* negative margins to get the border of the subnav to align with the pseudo element */
		margin-left: -1px;
		margin-right: -1px;
	}
`;
